import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { DesignationDDL } from '../../../../Components/CommonDDL/DesignationDDL';
import { DepartmentDataDDL } from '../../../../Components/CommonDDL/DepartmentDataDDL';
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { EmployeePostDataAPI } from '../../../../Redux/SidebarMasterSlice/EmployeeSlice';
import { RegExOnlyText } from '../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../Helper/AstricSign';
import { RoleNameDataDDL } from '../../../../Components/CommonDDL/RoleNameDataDDL';
import { ProjectTypeDataDDL } from '../../../../Components/CommonDDL/ProjectTypeDataDDL';
import { ProjectNameIUDDL } from '../../../../Components/CommonDDL/ProjectNameIUDDL';


export default function EmployeePopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, item, EditIcon, apiFlag, rowData, } = props

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user
    const dispatch = useDispatch()

    // console.log("rowData: ", rowData);

    // const [rowData, setRowData] = useState(item)

    const [IsValidNumbers, setIsValidNumbers] = useState(false)
    const [IsValidEmail, setIsValidEmail] = useState(false)
    const [IsPost, setIsPost] = useState(false)

    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_DesignationID : 0,
        Label: Flag === 'Update' ? rowData.designationName : "Select...",
    })
    const [Department, setDepartment] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_DepartmentID : 0,
        Label: Flag === 'Update' ? rowData.departmentName : "Select...",

    })
    const [EmployeeName, setEmployeeName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
        Label: Flag === 'Update' ? rowData.projectType : "Select...",
    })

    const [ProjectNameIU, setProjectNameIU] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectID : 0,
        Label: Flag === 'Update' ? rowData.projectName : "Select...",
    })


    const [Role, setRole] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_RoleID : 0,
        Label: Flag === 'Update' ? rowData.role : "Select...",
    })

    const [EmployeeField, setEmployeeField] = useState({
        EmployeeName: Flag === 'Update' ? rowData.employeeName : '',
        MobileNumber: Flag === 'Update' ? rowData.mobileNumber : '',
        EmailID: Flag === 'Update' ? rowData.email_ID : ''
    })

    const handleEmployeeField = (e) => {
        setEmployeeField({ ...EmployeeField, [e.target.name]: e.target.value })
    }

    const [IsOpen, setIsOpen] = useState(false)

    // useEffect(() => {
    //     setEmployeeField({
    //         EmployeeName: Flag === 'Update' ? rowData.employeeName : '',
    //         MobileNumber: Flag === 'Update' ? rowData.mobileNumber : '',
    //         EmailID: Flag === 'Update' ? rowData.email_ID : ''
    //     })
    // }, [item, IsOpen])

    // console.log(Flag, EmployeeField)
    const handleClearField = () => {

        if (Flag != 'Update') {
            setEmployeeField({
                EmployeeName: '',
                MobileNumber: '',
                EmailID: ''
            })
        }
    }

    const [IsValidText, setIsValidText] = useState(false)
    const handleCheckText = (e) => {
        handleEmployeeField(e)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    const handleCheckMobileNumber = (e) => {
        handleEmployeeField(e)
        let regex = new RegExp(/^[0-9]*$/)
        if (regex.test(e.target.value) || e.target.value === "") {
            setIsValidNumbers(false)
        } else {
            setIsValidNumbers(true)
        }
    }

    const handleCheckEmail = (e) => {
        handleEmployeeField(e)
        let regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
        if (regex.test(e.target.value) || e.target.value === "") {
            setIsValidEmail(false)
        } else {
            setIsValidEmail(true)
        }
    }

    const handlePost = () => {
        const data = {
            M_DepartmentID: Department.ID ?? 0,
            M_EmployeeID: Flag === 'Update' ? rowData.m_EmployeeID : '0',
            M_DesignationID: Designation.ID,
            M_RoleID: 0,
            M_ProjectTypeID: RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID,
            M_ProjectID: ProjectNameIU?.ID,
            EmployeeName: EmployeeField.EmployeeName,
            MobileNumber: EmployeeField.MobileNumber,
            Email_ID: EmployeeField.EmailID,
            JoiningDate: '',
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleClearField: handleClearField,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(EmployeePostDataAPI({ data }))

    }

    return (
        // <Popup
        //     onOpen={() => setIsOpen(!IsOpen)}
        //     contentStyle={{ top: '5%' }}
        //     trigger={
        //         Flag === 'Update' ?
        //             <i className="fa-solid fa-pen-to-square" style={{ cursor: "pointer" }} title='Edit'></i>
        //             :
        //             <i className="fa-solid fa-plus btn btn-secondary float-end mb-2" style={{ color: "white", marginTop: '-2.5em' }}>
        //                 <text className="ml-2 poppins">Add</text>
        //             </i>
        //     }
        //     modal>



        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl  " >
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Project Wise Officer Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                {
                                    RoleID == 1 &&
                                    <div className="col-md-6 col-lg-6">
                                        <ProjectTypeDataDDL
                                            ProjectType={ProjectType}
                                            setProjectType={setProjectType}
                                            Flag={Flag}
                                            rowData={rowData}
                                        />
                                    </div>
                                }
                                <div className="col-md-6 col-lg-6">
                                    <ProjectNameIUDDL
                                        ProjectType={RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID}
                                        ProjectNameIU={ProjectNameIU}
                                        setProjectNameIU={setProjectNameIU}
                                         WardID={0}
                                        APIFlag="ProjectWiseContractor"
                                        Flag={Flag}
                                        rowData={rowData}
                                        IsPost={IsPost}
                                    />
                                </div>

                                {/* <div className="col-md-6 col-lg-6">
                                    <RoleNameDataDDL
                                        Role={Role}
                                        setRole={setRole}
                                        // rowData={item}
                                        rowData={rowData}
                                        Flag={Flag}
                                        Designation={Designation}
                                        setDesignation={setDesignation}
                                        M_ProjectTypeID={ProjectType?.ID}
                                    />
                                </div> */}
                                <div className="col-12 col-md-6 col-lg-6">
                                    <DesignationDDL
                                        Designation={Designation}
                                        setDesignation={setDesignation}
                                        rowData={rowData}
                                        Flag={Flag}
                                        IsPost={IsPost}
                                        M_RoleID={Role?.ID}
                                        M_ProjectTypeID={M_ProjectTypeID}
                                    />
                                </div>
                                {/* <div className="col-12 col-lg-6">
                                            <DepartmentDataDDL
                                                Department={Department}
                                                setDepartment={setDepartment}
                                                rowData={rowData}
                                                Flag={Flag}
                                            />
                                        </div> */}
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Employee Name <AstricSign /> </b></label>
                                        <input type="text" className="form-control" id="exampleInputEmail1" name='EmployeeName'
                                            aria-describedby="emailHelp"
                                            value={EmployeeField.EmployeeName}
                                            onChange={(e) => handleEmployeeField(e)}
                                        />
                                        {/* {
                                            IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                        } */}
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Mobile Number </b></label>
                                        <input type="text" className="form-control" id="exampleInputEmail1" name='MobileNumber'
                                            aria-describedby="emailHelp"
                                            value={EmployeeField.MobileNumber}
                                            onChange={handleCheckMobileNumber}
                                            maxLength={10}
                                        />
                                        {
                                            IsValidNumbers && <text style={{ color: 'red' }}>Please Enter valid Mobile Number</text>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Email Id </b></label>
                                        <input type="text" className="form-control" id="exampleInputEmail1" name='EmailID'
                                            aria-describedby="emailHelp"
                                            value={EmployeeField.EmailID}
                                            onChange={handleCheckEmail}
                                        />
                                        {
                                            IsValidEmail && <text style={{ color: 'red' }}>Please Enter valid Email</text>
                                        }
                                    </div>
                                </div>

                            </div>

                            <div className="col-12 col-lg-12  pt-md-4 pt-4">
                                <div className="btn-action d-flex justify-content-end ">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            Designation.ID == 0 || EmployeeField.EmployeeName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}